module.exports = __webpack_public_path__ + "img/JalaApp.32f4d9f8.svg";